/**
 * Chart theme — paleta central de series para TODAS las gráficas.
 *
 * Rotación aprobada por el cliente. Cualquier chart (recharts, three.js,
 * Chart.js, sparkbars) debe leer del array `CHART_COLORS` — no hardcodear.
 *
 * En modo claro y oscuro se usan los mismos valores: son colores brand que
 * deben verse consistentes entre temas. El contraste se resuelve con
 * fondos y bordes (no cambiando los HEX de las series).
 */
export const CHART_COLORS = [
  "#2563EB", // 1 · azul primario
  "#F97316", // 2 · naranja
  "#22C55E", // 3 · verde
  "#EF4444", // 4 · rojo
  "#EAB308", // 5 · amarillo
  "#8B5CF6", // 6 · púrpura fallback
  "#14B8A6", // 7 · teal fallback
  "#EC4899", // 8 · rosa fallback
];

// Alias legible para código que quiera pedir el color por nombre.
export const BRAND = {
  primary: "#2563EB",
  primaryHover: "#1D4ED8",
  accent: "#F97316",
  success: "#22C55E",
  warning: "#EAB308",
  danger: "#EF4444",
};

/**
 * Devuelve el color de serie N (0-indexed) con rotación circular.
 * @param {number} idx — índice de la serie
 * @returns {string} hex
 */
export function chartColor(idx) {
  if (idx == null || idx < 0) return CHART_COLORS[0];
  return CHART_COLORS[idx % CHART_COLORS.length];
}
